export default {
  id: 'Série e número',
  invoiceId: 'Série e número',
  title: 'Dados gerais',
  format: 'Formato de origem',
  created: 'Data de criação',
  issue: 'Data de emissão',
  incomeDate: 'Data de vencimento',
  help: 'Este dado deve ser preenchido se a data em que a operação foi realizada ou o pagamento antecipado foi recebido for diferente da data de emissão da fatura.',
  equalToEmisionDate: 'Igual à data de emissão',
  billingPeriod: 'Indicar período de faturação',
  billPeriod: {
    title: 'Período de faturação',
    start: 'Data de início',
    end: 'Data final'
  },
  billProcedure: {
    title: 'Fatura de crédito',
    serie: 'Série - Número',
    reason: 'Razão do crédito'
  },
  extra: {
    title: 'Informação adicional',
    concept: 'Conceito',
    import: 'Anexar novo arquivo'
  },
  addFile: {
    type: 'Tipo',
    description: 'Descrição*',
    date: 'Data de criação',
    fileTypeInfo: 'Para FACe, apenas são aceitos anexos nos formatos PDF e HTML'
  },
  serieAndBillNumber: 'Inserir série e número da fatura manualmente',
  necessaryToStoreBill: 'Necessário para armazenar a fatura respeitando a série e número externo indicados',
  serie: 'Série',
  number: 'Número',
  sendInvoiceAsPayment: 'Se selecionar esta opção, a fatura será enviada como um crédito a favor do cliente destinatário da fatura.',
  emissorDiscount: 'Portanto, o valor correspondente será descontado da conta associada ao emissor.',
  contactData: 'Dados de contato',
  addContactData: 'Adicionar dados de contato',
  onlyExpenses: 'Se deseja que a fatura seja apenas de reembolso, marque a opção correspondente',
  rectified: {
    title: 'Fatura retificada',
    reason: 'Razão da retificação',
    description: 'Descrição'
  },
  onlySupplied: 'A fatura é apenas de reembolso',
  status: 'Estado',
  reason: 'Motivo da rejeição',
  faceb2bData: 'Dados do FACeB2B'
}